module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/inhangar.0f6e18af.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/inhangar.png
// module id = 1047
// module chunks = 16